import React from 'react';
import { useQuery } from '@tanstack/react-query';
import { getLiveFolders } from '../api/mailbox';
import ThreadList from '../components/ThreadList';
import { Box, CircularProgress, Typography } from '@mui/material';

export default function InboxPage() {
  const { data, isLoading, isError } = useQuery({
    queryKey: ['live-folders', 'inbox'],
    queryFn: () => getLiveFolders(),
  });

  const inbox = data?.results?.find((f) => f.special_use === 'inbox');

  if (isLoading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', p: 4 }}>
        <CircularProgress />
      </Box>
    );
  }
  if (isError || !inbox) {
    return (
      <Box sx={{ p: 4 }}>
        <Typography color="text.secondary">
          {isError ? 'Could not load folders from IMAP.' : 'No Inbox folder found on the server.'}
        </Typography>
      </Box>
    );
  }

  return <ThreadList accountId={inbox.account} imapFolder={inbox.imap_name} title="Inbox" />;
}
